import React from 'react'
import './typography.scss'
import { useTheme } from '../../../contexts/ThemeProvider';
import { LIGHT_THEME } from '../../../utils/constants';

const Typography = () => {

    const letters = [
        "Aa", "Bb", "Cc", "Dd", "Ee", "Ff", "Gg", "Hh", "Ii", "Jj",
        "Kk", "Ll", "Mm", "Nn", "Oo", "Pp", "Qq", "Rr", "Ss", "Tt",
        "Uu", "Vv", "Ww", "Xx", "Yy", "Zz"
    ];

    const { theme } = useTheme();

    return (
        <>

            <section className='typography_bg'>
                <div className="brand-custom-container typography_main">
                    <div className="logo_heading">
                        <h3 className="brand_common_heading">
                            Brand Typography
                        </h3>
                        {/* <a href='\assets\brandassets\fonts.zip' className="brand__button">Download All</a> */}
                    </div>
                    <div className="typography_grid">
                        <div className="grid_child" style={theme === LIGHT_THEME ? { border: '1px solid #DEDEDE' } : {}}>
                            <p className="heading">FONT 1</p>
                            <h4 className='child_first_heading'>OBVIOUSLY</h4>
                            <div className="alphabet-grid">
                                {letters.map((pair) => (
                                    <span key={pair} className="alphabet-letter">{pair}</span>
                                ))}
                            </div>
                            <div className="line"></div>
                            <p className="desc_obv">The font we’re using is a modern typeface that blends elegance with readability. Its clean lines and balanced proportions enhance both digital and print media, conveying professionalism while remaining approachable.</p>
                            {/* <a href='\assets\brandassets\obviously.zip' className='font_btn'>DOWNLOAD FONT</a> */}
                        </div>
                        <div className="grid_child" style={theme === LIGHT_THEME ? { border: '1px solid #DEDEDE' } : {}}>
                            <p className="heading">FONT 2</p>
                            <h4 className='child_second_heading'>HELVETICA NOW DISPLAY</h4>
                            <div className="alphabet-grid">
                                {letters.map((pair) => (
                                    <span key={pair} className="alphabet-letter-second">{pair}</span>
                                ))}
                            </div>
                            <div className="line"></div>
                            <p className="desc">The font we’re using is a modern typeface that blends elegance with readability. Its clean lines and balanced proportions enhance both digital and print media, conveying professionalism while remaining approachable.</p>
                            {/* <a href='\assets\brandassets\helvetica-now-display.zip' className='font_btn'>DOWNLOAD FONT</a> */}
                        </div>
                    </div>
                </div>
            </section>

        </>
    )
}

export default Typography